module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Bold.cd5cf5da.otf";